import React from 'react';
import { ILine as Line } from '../../../../global';
import { getStartOfLine, getEndOfLine } from '../../../../utils';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  lineDuration: { marginBottom: theme.spacing(1) },
}));

interface Props {
  line: Line;
}

export default function MobileLineDuration({ line }: Props) {
  const classes = useStyles();
  const { stages } = line;
  const start = getStartOfLine(stages);
  const end = getEndOfLine(stages);

  const formattedStart = moment(start).format("MMM 'YY");
  const formattedEnd = moment(end).format("MMM 'YY");

  return (
    <Typography
      align="left"
      variant="subtitle1"
      className={classes.lineDuration}
    >
      {formattedStart} - {formattedEnd}
    </Typography>
  );
}
